import React from "react";
import parseNumber from "../../../../utils/parseCalculate";
import { Box } from "@mui/material";
import FlowDevice from "./Devices/FlowDevice";
import { useLiveDevice } from "../../../../hooks/useLiveDeviceData";

function Item(props) {
  const { sx, ...other } = props;
  return <Box {...other} />;
}

const FluidWrap = ({ name, deviceId, isExpired }) => {
  const { data, units, status } = useLiveDevice(isExpired ? null : deviceId, {
    watchStatus: true,
  });
  const deviceStatus = isExpired ? "inactive" : status;
  const flow = data ? parseNumber(data.flowrate) : "--";
  const totalFlow = data ? parseNumber(data.totalizer) : "--";

  return (
    <Item>
      <FlowDevice
        deviceStatus={deviceStatus}
        deviceId={deviceId}
        flowValue={
          isExpired
            ? "Subscription Expired"
            : `${flow} ${units.flow_unit || ""}`
        }
        totalFlowValue={
          isExpired ? "" : `${totalFlow} ${units.total_unit || ""}`
        }
        lastUpdated={
          isExpired
            ? ""
            : `
          ${
            data?.date_time
              ? new Date(data.date_time).toLocaleDateString("en-GB").slice(0, 10)
              : "--"
          } ${
            data?.date_time
              ? new Date(data.date_time).toLocaleTimeString("en-US", {
                  hour12: true,
                })
              : "--"
          }`
        }
        powerStatus={isExpired ? null : data?.battery}
        title={name}
      />
    </Item>
  );
};

export default FluidWrap;
